import * as React from "react";
import type { SVGProps } from "react";

/**
 * Sports Icon - 体育图标
 * Used for: Sports category
 */
const SportsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={21}
    viewBox="0 0 48 48"
    {...props}
    fill={"currentColor"}
    fillRule={"evenodd"}
    className={"cus-svg"}
  >
    <path d="m37.689 10.441-3.3 3.268a3.131 3.131 0 0 1-2.519.874l-11.834-2.4a2.333 2.333 0 0 1-1.788-1.239l-2.687-4.661a20.686 20.686 0 0 1 22.128 4.158ZM3.28 30.148l4.378-.437c.964-.119 1.479-.173 1.993.369l9.185 9.941a1.907 1.907 0 0 1 .266 2.01l-.853 3.436A20.724 20.724 0 0 1 3.28 30.148Zm8.884-22.08 2.878 4.705a1.925 1.925 0 0 1 .266 2.009l-5.4 10.308a1.987 1.987 0 0 1-1.829.873l-5.318.484c-.017-.339-.026-.68-.026-1.023a20.67 20.67 0 0 1 9.429-17.356ZM22.6 37.229a1.724 1.724 0 0 1-1.984-.416l-7.6-8.4a1.724 1.724 0 0 1-.217-2.015l5.641-9.829a1.725 1.725 0 0 1 1.85-.83l11.091 2.327a1.724 1.724 0 0 1 1.361 1.5l1.214 11.267a1.725 1.725 0 0 1-1.009 1.758Zm14.968-1.8 2.932 1.682a20.668 20.668 0 0 1-17.076 9.006c-.616 0-1.223-.032-1.825-.084l.731-3.449c.152-.928.292-1.46.966-1.782l11.951-5.574a2.267 2.267 0 0 1 2.319.198Zm-.3-5.059-1.14-11.924a2.146 2.146 0 0 1 .4-1.985l3.753-3.025a20.675 20.675 0 0 1 2.03 20.441l-3.651-1.692a2.07 2.07 0 0 1-1.392-1.818Z" />
  </svg>
);

export default SportsIcon;

